import { Controller } from '@hotwired/stimulus';
import { elementStyle } from '@inked/utilities';

export class EmptyController extends Controller {
  static values = {
    hiddenClass: {
      default: 'hidden',
      type: String,
    },
  };

  connect() {
    this.observer = new MutationObserver(() => this.visibility());
    this.observer.observe(this.element, {
      attributeFilter: [ 'class', 'hidden', 'style' ],
      childList: true,
      subtree: true,
    });

    this.visibility();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  visibility() {
    const hasVisible =
      [...this.element.childNodes].some(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '')
      || [...this.element.children].some(child => elementStyle(child, 'display') !== 'none');
    const isHidden = this.element.classList.contains(this.hiddenClassValue);

    if (hasVisible !== isHidden) return;

    this.element.classList.toggle(this.hiddenClassValue, !hasVisible);
    this.dispatch(hasVisible ? 'show' : 'hide');
  }
}
